import { useSearchParams } from "react-router-dom";

import { useRootContext } from "@client/context/RootContext";
import { CONFIG_KEYS } from "@client/stores/config-store/config-store";

export function useNotificationPopup() {
	const { configStore } = useRootContext();
	const [searchParams] = useSearchParams();

	// Get notification data from URL params or config store
	const title_url = searchParams.get("notification_title");
	const message_url = searchParams.get("notification_message");
	const enabled_config =
		configStore.getConfigValue(CONFIG_KEYS.NOTIFICATION_ENABLED) === "1";
	const title_config = configStore.getConfigValue(
		CONFIG_KEYS.NOTIFICATION_TITLE
	);
	const message_config = configStore.getConfigValue(
		CONFIG_KEYS.NOTIFICATION_MESSAGE
	);

	// Use URL params if available, otherwise use config store values
	const title = title_url || title_config;
	const message = message_url || message_config;

	// Show button if notification is enabled in config OR if we have both URL params
	const showNotificationButton = enabled_config || (title_url && message_url);

	return {
		showNotificationButton,
		title,
		message,
		title_url,
		message_url,
		title_config,
		message_config,
		enabled_config,
	};
}
